import { render, staticRenderFns } from "./CoreHeader.vue?vue&type=template&id=7aa26787&scoped=true"
import script from "./CoreHeader.vue?vue&type=script&lang=js"
export * from "./CoreHeader.vue?vue&type=script&lang=js"
import style0 from "./CoreHeader.vue?vue&type=style&index=0&id=7aa26787&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa26787",
  null
  
)

export default component.exports